export default "__VITE_ASSET__CrR9PExC__"